//NETWORK
export const FETCH_NETWORK_SUCCESS = "fetchnetwork";
